/* KeyCodes de comandos e modifiers a serem ignorados pela formatação de campos */
export const ignoredFormKeyCodes = [
  3, // CANCEL
  8, // BACKSPACE
  9, // TAB
  16, // SHIFT
  17, // CTRL
  18, // ALT
  20, // CAPS LOCK
  27, // ESC
  33, // PG UP
  34, // PG DOWN
  35, // END
  36, // HOME
  37, // ARROW LEFT
  38, // ARROW UP
  39, // ARROW RIGHT
  40, // ARROW DOWN
  41, // SELECT
  42, // PRINT
  43, // EXECUTE
  44, // F13/PRINTSCREEN
  45, // INSERT
  46, // DELETE
  91, // Meta (Mac Key)
  92, // Meta (Mac Key)
  93, // Context Menu
  112, // F1
  113, // F2
  114, // F3
  115, // [...]
  116,
  117,
  118,
  119,
  120,
  121,
  122, // [...]
  123, // F12
  124, // F13
  125, // F14
  126, // [...]
  127,
  128,
  129,
  130,
  131,
  132,
  133,
  134,
  135,
  136,
  137,
  138,
  139,
  140,
  141, // [...]
  142, // F31
  143, // F32
  144, // Num Lock
  145, // Scroll Lock
  166, // Browser Back
  167, // Browser Forward
  168, // Browser Refresh
  174, // [Media Key]
  175, // [Media Key]
  176, // [Media Key]
  177, // [Media Key]
  178, // [Media Key]
  179, // [Media Key]
  180, // [Media Key]
  181, // [Media Key]
  182, // [Media Key]
  183, // [Media Key]
  224, // Meta (Mac key)
  225, // Alt (Mac Key)
];
